import React from "react";
import { Button } from "reactstrap";

import { IButtonProps } from "../../../interfaces/Index";
import "./ButtonComponent.scss";

const ButtonComponent: React.FunctionComponent<IButtonProps> = (props) => {
  return (
    <Button
      className={props.buttonClass}
      onClick={props.onClickHandler}
      style={props.buttonStyles}
      disabled={props.isDisable}
    >
      {props.buttonText}
    </Button>
  );
};

ButtonComponent.defaultProps = {
  buttonClass: "btn-primary",
  onClickHandler: () => {},
  buttonStyles: {
    padding: "6px 30px",
  },
  isDisable: false, 
};

export default ButtonComponent;
